if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductFrom extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.errorContainer = this.querySelector('[data-error-container]');
      }

      get discount() {
        if (!this.hasAttribute('data-code')) return null;
        return window.atob(this.dataset.code);
      }

      get extraDiscount() {
        if (!this.hasAttribute('data-extra')) return null;
        return window.atob(this.dataset.extra);
      }

      get stickyOnMobile() {
        return this.hasAttribute('data-sticky-mobile');
      }

      get sectionsToUpdate() {
        let sections = 'cart-icon-bubble,cart-drawer';
        if (window.location.href.includes('/cart')) {
          sections = 'cart-icon-bubble,main-cart-extend';
        }

        return sections;
      }

      connectedCallback() {
        if (!this.form) return;
        this.form.addEventListener('submit', (event) => this.handleAddToCart(event));
        this.updateCartAttrribute();
      }

      async handleAddToCart(event) {
        event.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton) this.submitButton.disabled = true;

        const upsellCard = this.closest('[data-cart-upsell]');
        if (upsellCard) {
          upsellCard.classList.add('loading');
        }
        this.lockScroll();
        this.addToCartFromForm(upsellCard);
      }

      async handleApplyDiscount(upsellCard) {
        const url = `${window.Shopify.routes.root}cart/update.js`;
        const data = {
          discount: this.discount,
          sections: this.sectionsToUpdate,
          sections_url: window.location.pathname,
        };
        const request = {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Access-Control-Allow-Origin': 'no-cors',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        };

        Promise.resolve().finally(async () => {
          const res = await this.fetchWithRetry(url, request);
          const result = await res.json();
          !res.ok ? this.onCartError(result) : this.onCartSuccess(result, upsellCard);
        });
      }

      onCartSuccess(result, upsellCard) {
        if (this.submitButton) {
          this.submitButton.disabled = false;
        }
        if (upsellCard) {
          upsellCard.classList.remove('loading');
        }
        const afterAddEvent = new CustomEvent('switch:cart:afteradditem', {
          bubbles: true,
          detail: { response: result },
        });
        document.dispatchEvent(afterAddEvent);
      }

      onCartError(result) {
        if (result.description || result.message) {
          const errors = result.description || result.message;
          this.errorContainer.innerHTML = errors;
          this.errorContainer.classList.remove('hidden');
        } else {
          this.errorContainer.classList.add('hidden');
        }
        if (this.submitButton) {
          this.submitButton.disabled = false;
        }
        return;
      }

      lockScroll() {
        const isFirefox = typeof InstallTrigger !== 'undefined';
        if (isFirefox) {
          document.body.style.overflow = 'hidden';
        } else {
          const scrollY = window.scrollY;
          document.body.dataset.scrollY = scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${scrollY}px`;
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.overscrollBehavior = 'none';
        }
      }

      unlockScroll() {
        const isFirefox = typeof InstallTrigger !== 'undefined';
        if (isFirefox) {
          document.body.style.overflow = 'auto';
        } else {
          const scrollY = document.body.dataset.scrollY || '0';
          document.body.removeAttribute('style');
          window.scrollTo({
            top: parseInt(scrollY, 10),
            behavior: 'instant',
          });
        }
      }

      async handleApplyPromoDiscount(addToCartResult, upsellCard) {
        const url = `${window.Shopify.routes.root}cart.js`;
        const response = await fetch(url);
        const result = await response.json();
        if (this.extraDiscount) {
          const extraDiscountInCart = result.discount_codes.find((item) => item.code === this.extraDiscount && item.applicable);
          extraDiscountInCart ? this.onCartSuccess(addToCartResult, upsellCard) : this.handleApplyDiscount(upsellCard);
        } else {
          this.handleApplyDiscount(upsellCard);
        }
      }

      async updateCartAttrribute() {
        if (!window.location.href.includes('blackweekpresale') || this.hasAttribute('data-hide-update')) return;
        const url = `${window.Shopify.routes.root}cart/update.js`;
        const data = {
          attributes: {
            _black_week_presale: true,
          },
        };

        const request = {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Access-Control-Allow-Origin': 'no-cors',
            'Content-Type': 'application/json',
            credentials: 'same-origin',
          },
          body: JSON.stringify(data),
        };

        Promise.resolve().finally(async () => {
          const res = await this.fetchWithRetry(url, request);
          const result = await res.json();
          if (response.ok) {
            console.log(result, 'Black week presale enabled');
          }
        });
      }

      async fetchWithRetry(url, init, retries = 2) {
        for (let i = 0; i <= retries; i++) {
          const res = await fetch(url, init);
          if (res.status !== 409) return res;
          await new Promise((r) => setTimeout(r, 150 * (i + 1)));
        }
        throw new Error('Cart busy after retries');
      }

      addToCartFromForm(upsellCard) {
        const url = theme.routes.cart_add_url;
        const data = new FormData(this.form);
        data.set('sections', this.sectionsToUpdate);
        data.set('sections_url', window.location.pathname);
        const config = {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Access-Control-Allow-Origin': 'no-cors',
            Accept: 'application/javascript',
            credentials: 'same-origin',
          },
          body: data,
        };

        Promise.resolve().finally(async () => {
          const res = await this.fetchWithRetry(url, config);
          const result = await res.json();
          if (!res.ok) {
            this.onCartError(result);
          } else {
            this.discount ? this.handleApplyPromoDiscount(result, upsellCard) : this.onCartSuccess(result, upsellCard);
          }
        });
      }
    },
  );
}
